import myconfig from '../Config';

class RestService<T> {
    static isLoading = false; // Added isLoading property


    private static getAuthHeader(): HeadersInit {
        const token = localStorage.getItem('myToken');
        return {
            'Content-Type': 'application/json',
            ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        };
    }

    static async get<T>(url: string): Promise<T> {
        try {
            this.isLoading = true; // Start loading
            const response = await fetch(myconfig.rootUrl + url, {
                method: 'GET',
                headers: this.getAuthHeader(),
            });

            if (!response.ok) {
                const raw = await response.text();
                let message = raw;
                try {
                    const parsed = JSON.parse(raw);
                    if (parsed?.Message) message = parsed.Message;
                    else if (parsed?.message) message = parsed.message;
                    else if (typeof parsed === 'string') message = parsed;
                } catch {
                    // not JSON — use raw text as-is
                }
                throw new Error(message || `Error: ${response.status}`);
            }

            const data = await response.json() as T;
            this.isLoading = false; // Stop loading
            return data;
        } catch (error) {
            this.isLoading = false; // Stop loading on error
            throw error instanceof Error ? error : new Error(String(error));
        }
    }

    static async post<T, R>(url: string, data: T): Promise<R> {
        try {
            this.isLoading = true; // Start loading
            const response = await fetch(myconfig.rootUrl + url, {
                method: 'POST',
                headers: this.getAuthHeader(),
                body: JSON.stringify(data),
            });

            if (!response.ok) {
                const raw = await response.text();
                let message = raw;
                try {
                    const parsed = JSON.parse(raw);
                    if (parsed?.Message) message = parsed.Message;
                    else if (parsed?.message) message = parsed.message;
                    else if (typeof parsed === 'string') message = parsed;
                } catch {
                    // not JSON — use raw text as-is
                }
                throw new Error(message || `Error: ${response.status}`);
            }

            const result = await response.json() as R;
            this.isLoading = false; // Stop loading
            return result;
        } catch (error) {
            this.isLoading = false; // Stop loading on error
            throw error instanceof Error ? error : new Error(String(error));
        }
    }

    static async del<R>(url: string): Promise<R> {
        try {
            this.isLoading = true; // Start loading
            const response = await fetch(myconfig.rootUrl + url, {
                method: 'DELETE',
                headers: this.getAuthHeader(),
            });

            if (!response.ok) {
                const raw = await response.text();
                let message = raw;
                try {
                    const parsed = JSON.parse(raw);
                    if (parsed?.Message) message = parsed.Message;
                    else if (parsed?.message) message = parsed.message;
                    else if (typeof parsed === 'string') message = parsed;
                } catch {
                    // not JSON — use raw text as-is
                }
                throw new Error(message || `Error: ${response.status}`);
            }

            const result = await response.json() as R;
            this.isLoading = false; // Stop loading
            return result;
        } catch (error) {
            this.isLoading = false; // Stop loading on error
            throw error instanceof Error ? error : new Error(String(error));
        }
    }

}

export default RestService;
